<div class="app-shell" [class.sidenav-collapsed]="sidenavCollapsed">

  <!-- Left column: full-height sidebar -->
  <app-sidenav [collapsed]="sidenavCollapsed"></app-sidenav>

  <!-- Right column: header + scrollable content + footer -->
  <div class="app-right">
    <app-header (menuToggle)="toggleSidenav()"></app-header>

    <main class="app-main">
      <router-outlet></router-outlet>
    </main>

    <app-footer></app-footer>
  </div>

</div>
